'use strict'

var config, service, einvoices;
(async () => {
  if (!config || !service) {
    await getConfigFile();
  }
})();

async function getConfigFile() {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.VUE_APP_MOL_API_GATEWAY
  einvoices = config.VUE_APP_MOL_S_EINVOICES
}

async function trasferisciXml(documentoId, nomeFile, link) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      documentoId,
      nomeFile,
      link
    }
    const response = await fetch(`${service}/${einvoices}/upload`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

async function out_findByUsername(username, startDate, endDate, countrySender, vatcodeSender) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      username, startDate, endDate, countrySender, vatcodeSender
    }
    const response = await fetch(`${service}/${einvoices}/out/findByUsername`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

async function out_getByFilename(filename) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      filename
    }
    const response = await fetch(`${service}/${einvoices}/out/getByFilename`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

async function in_findByUsername(username, startDate, endDate, countryReceiver, vatcodeReceiver) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      username, startDate, endDate, countryReceiver, vatcodeReceiver
    }
    const response = await fetch(`${service}/${einvoices}/in/findByUsername`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

async function in_getByFilename(filename) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      filename
    }
    const response = await fetch(`${service}/${einvoices}/in/getByFilename`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

async function in_getInvoiceWithUnsignedFile(invoiceId) {
  if (!config || !service) {
    await getConfigFile();
  }
  try {
    const data = {
      invoiceId
    }
    const response = await fetch(`${service}/${einvoices}/in/getInvoiceWithUnsignedFile`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (error) {
    console.log(error)
  }
}

export default {
  trasferisciXml,
  out_findByUsername,
  out_getByFilename,
  in_findByUsername,
  in_getByFilename,
  in_getInvoiceWithUnsignedFile
}
